import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { ShareInEmailGenericNavigation } from './navigation/share-in-email-generic-navigation';
import { ShareInEmailBody } from './share-in-email-body';

export const ShareInEmailNavigationSwitch = () => {
  return <StepNavigationSwitch body={ShareInEmailBody} generic={ShareInEmailGenericNavigation} />;
};
